import { render, staticRenderFns } from "./form-0b2c6193.vue?vue&type=template&id=485f5311&"
import script from "./form-0b2c6193.vue?vue&type=script&lang=js&"
export * from "./form-0b2c6193.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports